import "jquery.cookie";

const ssoTool = {
    showLoading() {
        $('#loading').removeClass('d-none');
    },
    hideLoading() {
        $('#loading').addClass('d-none');
    },
    setInputClearSwitch(target) {
        const targets = Array.isArray(target) ? target : [target];
        targets.forEach((selector) => {
            const input = $(selector);
            const icon = input.next('i[name="clear"]');

            icon.addClass('d-none');

            const syncIcon = () => {
                const focused = input.is(':focus');
                icon.toggleClass('d-none', !focused || input.val() === '' || input.prop('disabled'));
            };

            input.on('focus blur input change', syncIcon);

            icon.on('mousedown', function(e) {
                e.preventDefault();
                input.val('').trigger('input change');
            });
        });
    },
    syncClearIcons(container, exclude = null) {
        $(container).find('input:text').not(exclude ?? '').each(function() {
            $(this).next('i[name="clear"]').toggleClass('d-none', $(this).val() === '');
        });
    },
    hideClearIcons(container) {
        $(container).find('.input-action[name="clear"]').addClass('d-none');
    },
    setInputEyeSwitch(target) {
        const input = $(target);
        const icon = input.nextAll('i').not('[name="clear"]').first();

        icon.on('click', function() {
            let eyeName = $(this).attr('name');
            let inputType = eyeName === 'eye' ? 'text' : 'password';
            let eyeAttr = eyeName === 'eye' ? 'eye-off' : 'eye';

            input.prop('type', inputType);
            icon.attr('name', eyeAttr);
        });
    },
    setCookie(name, value, options = null) {
        const defaultOption = { expires: 60 * 24 * 30, path: '/' }
        const finalOption = $.extend(defaultOption, options);

        $.cookie(name, value, finalOption);
    },
    getCookie(name) {
        return $.cookie(name);
    }
};

export default ssoTool;
